import "core-js";
import React from "react";
import { MuiThemeProvider } from "@material-ui/core";
import { Provider } from "react-redux";
import store from "./redux/store";
import "./index.css";
import App from "./containers/App/App.container";
import * as serviceWorker from "./serviceWorker";
import { RecoilRoot } from "recoil";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import theme from "./theme";

const container = document.getElementById("root");
const root = createRoot(container);

const DEBUG = false; // set to false to disable debugging
const old_console_log = console.log;
console.log = function () {
  if (DEBUG) {
    old_console_log.apply(this, arguments);
  }
};

const reactQueryConfig = {
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
};

const queryClient = new QueryClient(reactQueryConfig);

root.render(
  <Provider store={store}>
    <MuiThemeProvider theme={theme}>
      <RecoilRoot>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </RecoilRoot>
    </MuiThemeProvider>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
